export default "__VITE_ASSET__47e5c944__"